import React from 'react';
import { Section } from 'components/shared';
import { IconBlock } from 'components/components/organisms';

const Amenities = ({ fields, rendering }) => {
  const data = fields.value[0];

  if (!data) {
    return null;
  }

  const items = data.subItems || [];
  const title = data.title;
  const filteredItems = items.filter((item) => item.title);
  const { componentName } = rendering;

  if (filteredItems.length < 4) {
    return null;
  }

  return (
    <Section id={componentName.toLowerCase()}>
      <IconBlock items={filteredItems} title={title} isAmenities={true} />
    </Section>
  );
};

export default Amenities;
